import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const ChassisNo = (props) => {
  return (
    <FormGroup controlId="chassisNo">
      <Col componentClass={ControlLabel} sm={5}>
        Chassis Number **
      </Col>
      <Col sm={7}>
          <FormControl type="text" value={props.chassisNo} onChange={props.handleChangeChassisNo}
            autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

ChassisNo.propTypes = {
  chassisNo: PropTypes.string,
  handleChangeChassisNo: PropTypes.func
};

export default ChassisNo;



// WEBPACK FOOTER //
// ./src/app/components/chassisNo/ChassisNo.js